import { render, staticRenderFns } from "./Index4.vue?vue&type=template&id=935168c0&scoped=true&"
import script from "./Index4.vue?vue&type=script&lang=js&"
export * from "./Index4.vue?vue&type=script&lang=js&"
import style0 from "./Index4.vue?vue&type=style&index=0&id=935168c0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "935168c0",
  null
  
)

component.options.__file = "Index4.vue"
export default component.exports